/* eslint-disable */
/* tslint:disable */

import { useEffect, useState } from 'react';
import middleBanner from '../../images/middle.png';

import TimeLine from '../../components/timeline/timeline';
import arrowRight from '../../images/arrow-right.svg';
import MatchInfo from './matchInfo';

import { getEnv } from '../../helpers/mobx-easy-wrapper';
import { NoticeItem } from '../activity/notice/notice';
import MatchEnter from './enter';
import PrizeInfo from './prize';
import TrendNews from './trendNews';

const Home = () => {
  const month = new Date().getMonth() + 1;

  const [category, setCategory] = useState('公告');
  const [data, setData] = useState<Array<NoticeItem>>();

  useEffect(() => {
    const { apiFactory } = getEnv();
    async function fetchData() {
      const response = await apiFactory.activityService.getNoticeData(1, '');
      setData(response.items);
    }
    fetchData();
  }, []);

  return (
    <div className='home'>
      {/*  <Banner />*/}
      <MatchInfo />

      <div className='home-full-row bg_fill' style={{ backgroundImage: `url(${middleBanner})` }}>
        <div className='middleBanner-cover'>
          <div className='middleBanner-desc'>
            激活专利价值，赋能创新龙江
            {/* <p>
              在十四五开局之年，上海市为提升上海高校院所专利转化实施效益，促进上海专利技术成果更多惠及中小企业发展，
              <strong>制定了《上海市实施专利转化专项计划工作方案（2021-2023）》，</strong>
              实施两年来，上海涌现一批优质的专利运营项目，带动专利运营服务机构开展专业化服务，转让、许可、金融等专利运营案例层出不穷。2022年首届上海市高价值专利运营大赛的成功举办，为2023年的大赛奠定了基础。2023年大赛再次启动，将紧扣专利运营工作助力上海创新发展的主题，尤其专利运营赋能上海企业发展需求，为专项计划长尾工作注入新动力。
            </p> */}
          </div>
        </div>
      </div>
      {/*     <div style={{ height: '450px' }}></div>*/}

      <div className='jury__line outlineTitle' style={{ textAlign: 'center', marginBottom: '60px', marginTop: '65px' }}>
        <label className={`enter_label  active `}>大赛赛程</label>
      </div>

      <div className='home-row schedule_time'>
        <TimeLine />
      </div>
      <div className='home-row' style={{ marginBottom: '64px' }}>
        <div
          onClick={() => {
            window.location.href = '/schedule';
          }}
          className='link-detail container-linkDetail'
        >
          <img src={arrowRight} />
          查看大赛赛程详情
        </div>
      </div>
      {/* 决赛结果 */}
      {/* <MatchEnter /> */}

      <PrizeInfo />

      {/* <div className='jury__line outlineTitle' style={{ textAlign: 'center', paddingTop: '0' }}>
        <label className={`enter_label  active `}>专家团队</label>
      </div>

      <JuryWidget /> */}

      <TrendNews />

      <div className='jury__line outlineTitle' style={{ textAlign: 'center', marginTop: '128px' }}>
        <label className={`enter_label  active `}>组织机构</label>
      </div>
      <div className='home-row org-container row-padding' style={{ marginTop: '62px' }}>
        <div className='org-subTitle'>指导单位</div>
        <div className='org-subUnit'>
          <div className='unitName'>
              黑龙江省知识产权局
          </div>
          <div className='unitName'>
              黑龙江省科学技术厅
          </div>
          <div className='unitName'>
              黑龙江省工业和信息化厅
          </div>
          <div className='unitName'>
              黑龙江省人民政府国有资产监督管理委员会
          </div>
        </div>
      </div>
      <div className='home-row org-container row-padding' style={{ marginTop: '30px' }}>
        <div className='org-subTitle'>主办单位</div>
        <div className='org-subUnit'>
          <div className='unitName'>
              黑龙江交易集团有限公司
          </div>
        </div>
      </div>

      <div className='home-row org-container row-padding' style={{ marginTop: '32px', marginBottom: '128px' }}>
        <div className='org-subTitle'>承办单位</div>
        <div className='org-subUnit'>
          <div className='unitName'>黑龙江股权交易中心有限责任公司</div>
          <div className='unitName'>（黑龙江科技成果和知识产权交易平台）</div>
          <div className='unitName tip'>(排名不分先后，按拼音首字母排序)</div>
        </div>
      </div>
    </div>
  );
};

export default Home;
